import styled from "styled-components"
import {CHART_PADDING_X, CHART_PADDING_Y} from "components/charts/Chart.constants"

export const CardContentContainer = styled.div`
  padding: ${CHART_PADDING_Y}px ${CHART_PADDING_X}px ${CHART_PADDING_Y}px ${CHART_PADDING_X}px;
`

export const TooltipRowWithIcon = styled.div<{$layout: "row" | "column", $justifyContent?: "start" | "end", $color?: string}>`
    display: flex;
    ${({$justifyContent}) => `justify-content: ${$justifyContent ?? 'start'};`}
    ${({$layout}) => `flex-direction: ${$layout};`}
    ${({$color}) => `color: ${$color};`}
    gap: 10px;
`
export const TooltipCategory = styled.div`
    font-weight: 500;
    width: 100%;
    text-align: center;
    padding-bottom: 5px;
    font-size: 17px;
`

export const TooltipContent = styled.div<{$width?: number}>`
  max-width: ${({$width}) => $width ? `${$width}px` : "315px"};
    padding: 20px;
    line-height: 23px;
    display: flex;
    flex-direction: column;
    gap: 7px;
  `

export const TooltipIconLayout = styled.div`
  height: 38px;
  `